<div class="provider-card">
  <div class="provider-img-badges">
    <img alt="Provider image" #img class="provider-image" [src]="getImagePath()" (error)="img.src = getFallbackImage()" />
    <div class="accept-patient" *ngIf="provider.acceptingNewPatients">
      <fal-badges></fal-badges>
    </div>
  </div>
  <h3 class="provider-card-header">
    {{provider.displayFullName}}
    <div class="imageDisplay" *ngFor="let image of marketCodeImage ">
     <img *ngIf="provider.medicalGroupIds.length > 0" src="{{deployUrl}}{{image.link}}" alt="" class="provider-logo" />
  </div>
  </h3>

  <div class="provider-specialties-container">
    <p>{{provider.primarySpecialty}}</p>
    <p *ngIf="provider?.secondarySpecialty!.length > 0">+{{this.provider.secondarySpecialty.length}}</p>
  </div>
  <div class="view-profile-container">
    <strong (click)="viewProfileClick()">
      <a>View Profile</a>
    </strong>
  </div>
</div>
